module.exports = __webpack_public_path__ + "static/media/lColumn.003465bd.gif";